export enum EProductExpansionEntryPoint {
  NEW_PRODUCT_BUTTON,
}
